import styled from "styled-components";

export const DepositHeaderButtonBox = styled.div`
    width: 27px;
    height: 18px;
    background: url(${({theme}) => theme.images.depositHeaderIcon.toString()});
    margin-right: 10px;
    cursor: pointer;
`;
